export interface DeleteBlockedState {
  title: string;
  body: string;
}

export const getDeleteBlockedState = (
  isLastPog: boolean,
  approvedCount: number,
  eligibleCount: number,
): DeleteBlockedState | null => {
  if (isLastPog) {
    return {
      title: "Cannot delete the last planogram",
      body: "At least one planogram must remain in the store.",
    };
  }

  if (approvedCount > 0) {
    const label = approvedCount === 1 ? "planogram is" : "planograms are";
    return {
      title: "Cannot delete approved planograms",
      body: `${approvedCount} approved ${label} in your selection. Please unapprove before deleting.`,
    };
  }

  if (eligibleCount <= 0) {
    return {
      title: "No planograms to delete",
      body: "All selected planograms are currently in progress and will be skipped.",
    };
  }

  return null;
};

export const getPogDeleteLabel = (count: number): string => `planogram${count === 1 ? "" : "s"}`;
